import React from 'react';
import { db } from '../firebaseConfig'; // Asegúrate que esta ruta apunta a firebase.js
import { collection, addDoc } from 'firebase/firestore';

const TestFirebase = () => {
  const subirPrueba = async () => {
    try {
      await addDoc(collection(db, 'usuarios'), {
        nombre: 'Prueba Firebase',
        correo: 'prueba@ampi.com',
        tipo: 'asesor'
      });
      alert('Documento subido con éxito a Firestore');
    } catch (error) {
      console.error('Error al subir documento:', error);
      alert('Error al subir documento');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Prueba de Conexión Firebase</h2>
      <p>Este botón creará un nuevo documento en la colección <code>usuarios</code>.</p>
      <button onClick={subirPrueba}>Subir documento de prueba</button>
    </div>
  );
};

export default TestFirebase;
